import { render } from "./accounts.vue?vue&type=template&id=4b161afb"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"
script.render = render

export default script